import { createMachine, assign } from 'xstate';
import { WebkassaRequestDetail } from '@fingermarkglobal/types';
import { endShift } from '../requests/end-shift';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;

    if (data) {
      logger.debug(`[fm-api][shift/end] - data received:`, data);
      return data;
    }

    if (error) {
      logger.error(`[fm-api][shift/end] - error received:`, error);
      return error;
    }

    logger.error(`[fm-api][shift/end] - message received:`, message);
    return message;
  },
});

const createEndShiftMachine = ({ payload = null, timeout = 30, ip = '', provider = '' } = {}) =>
  createMachine<{
    data: unknown;
    timeout: number;
    payload: null | WebkassaRequestDetail;
    provider: string;
  }>(
    {
      id: 'endShift',
      initial: 'processing',
      context: {
        payload,
        timeout,
        data: null,
        provider,
      },
      states: {
        processing: {
          invoke: {
            src: ({ payload, timeout }) => endShift(payload, timeout, ip, provider),
            onDone: {
              target: 'success',
              actions: ['populateMessage'],
            },
            onError: {
              target: 'error',
              actions: ['populateMessage'],
            },
          },
        },
        success: {
          on: {
            IDLE: 'processing',
          },
        },
        error: { type: 'final', entry: ['populateMessage'] },
      },
    },
    {
      actions: {
        populateMessage,
      },
    },
  );

export { createEndShiftMachine };
